import type { GivingDetail } from 'models';
import { Alert, Card, Icon } from 'ui';

type P = {
  giving: GivingDetail;
};

const FinishedAlertCard = ({ giving }: P) =>
  giving.status === 'finished' ? (
    <Card>
      <Alert description="Giving finished" icon={<Icon icon="calendar-time-add-fill" />} type="neutral" />
    </Card>
  ) : null;

export default FinishedAlertCard;
